export default "__VITE_ASSET__CVtHSkIz__"